var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27011",
    "data-name": "Group 27011",
    transform: "translate(-282 -195)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_167",
    "data-name": "Ellipse 167",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(282 195)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26524",
    "data-name": "Group 26524",
    transform: "translate(282 195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37724",
    "data-name": "Path 37724",
    d: "M10.375,2.375a8,8,0,0,1,5.657,13.657A8,8,0,0,1,4.718,4.718,7.948,7.948,0,0,1,10.375,2.375Zm0,14.976a6.975,6.975,0,1,0-4.933-2.043A6.931,6.931,0,0,0,10.375,17.351Z",
    transform: "translate(-2.375 -2.375)",
    fill: "#00b76f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37725",
    "data-name": "Path 37725",
    d: "M-1104.048,506.139l-2.436-2.428.723-.725,1.709,1.7,4.567-4.606.727.721Z",
    transform: "translate(1110.652 -495.073)",
    fill: "#00b76f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.26a0cc8b98104800921101b8250376b9.svg";
export { ForwardRef as ReactComponent };